import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'virguleToPoint'
})
export class VirguleToPointPipe implements PipeTransform {

  transform(value: number | string | null | undefined): number | null {
    if (value === null || value === undefined) {
      return null;
    }

    const cleanedValue = value.toString().replace(',', '.');
    const parsedValue = Number(cleanedValue);

    return isNaN(parsedValue) ? null : parsedValue;
  }

}
